import { TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';
// import { OldBreakPoints } from '@picsart/rc/enums';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { FontWeights } from '@picsart/rc/fonts';

const useStyles = createUseStyles<string, { titleColor?: string }>(
  {
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: Spacings.s48,
    },
    header: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: Spacings.s16,
    },
    grid: {
      width: '100%',
      display: 'grid',
      justifyContent: 'center',
      gridTemplateColumns: 'repeat(4, minmax(154px, 1fr))',
      gap: Spacings.s24,

      // [mediaQuery(OldBreakPoints.small)]: {
      '@media screen and (max-width: 768px)': {
        gridTemplateColumns: 'repeat(2, minmax(154px, 256px))',
      },
    },
    title: {
      textAlign: 'center',
      '& i': {
        color: ({ titleColor }) => titleColor || 'currentColor',
        fontStyle: 'normal',
      },
    },
    description: {
      fontSize: FontSizes.s20,
      fontWeight: FontWeights.Medium,
      color: TextColors.base,
      '&&': {
        '&& a': {
          color: 'currentColor',
          transition: 'opacity .2s ease-in-out',
          fontWeight: FontWeights.SemiBold,
          '&:hover': {
            opacity: '.7',
          },
        },
      },

      // [mediaQuery(OldBreakPoints.small)]: {
      '@media screen and (max-width: 768px)': {
        textAlign: 'center',
      },
    },
    // Skeleton
    itemSkeleton: {
      maxWidth: '100%',
      height: 154,
      borderRadius: CornerRadius.r20,
    },

    titleSkeleton: {
      width: 300,
      height: 50,
      maxWidth: '100%',
    },
    descriptionSkeleton: {
      width: 500,
      height: 40,
      maxWidth: '100%',
    },
  },
  {
    name: 'page-linking-component',
  },
);

export default useStyles;
